import React, { useEffect } from "react";
import { useVehicles } from "../../hooks/VehicleContext";

export default function VehicleSelector({
  selected,
  onSelect,
  onMoreInfo,
  disableAutoSelect = false,
}) {
  const { vehicles, loading } = useVehicles();

  useEffect(() => {
    if (disableAutoSelect) return;

    // If nothing is selected, select the first one by default if vehicles exist
    if (!loading && !selected && vehicles.length > 0) {
      onSelect(vehicles[0].id);
    }
  }, [loading, selected, vehicles, onSelect, disableAutoSelect]);

  if (loading) {
    return (
      <>
        <div className="form_title">
          <h3>Preferred Vehicle </h3>
        </div>
        <div className="vehicle_type">
          {[1, 2, 3].map((i) => (
            <div key={i} className="vehicle_select skeleton">
              <div
                style={{
                  height: "30px",
                  width: "80px",
                  margin: "0 auto 10px",
                  padding: "0",
                  backgroundColor: "rgba(0,0,0,0.05)",
                  borderRadius: "5px",
                }}
              ></div>
              <div
                className="skeleton-text"
                style={{ width: "70%", margin: "0 auto", padding: "0" }}
              ></div>
              <div
                className="skeleton-text"
                style={{ width: "50%", margin: "0 auto", padding: "0" }}
              ></div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="form_title">
        <h3>Preferred Vehicle </h3>
        <a
          href="#!"
          className="info_modal"
          data-bs-toggle="modal"
          data-bs-target="#vehicleInfoModal"
          onClick={(e) => {
            e.preventDefault();
            if (onMoreInfo) onMoreInfo();
          }}
        >
          More Info
        </a>
      </div>
      <div className="vehicle_type">
        {vehicles.map((v) => (
          <div
            key={v.id}
            className={`vehicle_select${Number(selected) === Number(v.id) ? " active" : ""}`}
            onClick={() => onSelect(v.id)}
            style={{ cursor: "pointer" }}
          >
            {/* <img src={v.image_url} alt={v.name} /> */}
            <img src="/assets/img/all-images/sedan1.png" alt={v.name} />
            <p>
              {v.name}
              <br />
              <small>
                {v.seater} Seats - {v.luggage} Bags
              </small>
            </p>
          </div>
        ))}
      </div>
    </>
  );
}
